import { http } from '../util/http'
import { fetchData } from '../util/index'
import { API_KOTLIN_DOMAIN, API_DOMAIN } from '../config'
import headers from './employeeSystemHeader'

// 商品管理查询商品仓库列表
export const getStores = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store`,
  })
}

// 商品管理查询商品分类列表
export const getCategories = (club_id) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/category`,
    params: {
      clubId: club_id,
    },
  })
}

// 商品管理查询商品列表
export const getCommodities = (storeId, categoryId, keyword) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing`,
    params: {
      categoryId: categoryId,
      storeId: storeId,
      keyword: keyword,
    },
  })
}

// 俱乐部商品详情(get条形码, 详情)
export const getCommodityDetail = (listingId, clubId, barCode) => {
  if (barCode) {
    return http({
      headers: headers(),
      url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/detail`,
      params: {
        listingId: listingId,
        clubId: clubId,
        barCode: barCode,
      },
    })
  } else {
    return http({
      headers: headers(),
      url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/detail`,
      params: {
        listingId: listingId,
        clubId: clubId,
      },
    })
  }
}

// 获取七牛token
export const fetchQiNiuToken = () => {
  return new Promise((resolve, reject) => {
    const endpoint = `${API_DOMAIN}/Home/CommodityApi/getQiniuToken`
    fetchData(endpoint).then((data) => {
      resolve(data)
    })
  })
}

// 图片上传至七牛
export const fetchQiniu = (form) => {
  return http({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url: 'https://up-z0.qbox.me/',
    method: 'post',
    data: form,
    isFile: true,
  })
}

// 查询下架列表
export const getPullOff = (clubId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/off`,
    params: {
      clubId: clubId,
    },
  })
}

// 新增或编辑商品信息
export const addOrEditCommodity = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing`,
    method: 'post',
    data,
  })
}

// 上架商品
export const onCommodity = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/on`,
    method: 'post',
    data,
  })
}

// 查询商品销售信息
export const getPrices = (listingIds) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/price`,
    params: {
      listingIds: listingIds,
    },
  })
}

// 新建/修改商品销售信息
export const postPrices = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/price`,
    method: 'post',
    data,
  })
}

// 查询商品详情页库存列表
export const getStockWarningList = (listingId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/detail/stores`,
    params: {
      listingId: listingId,
    },
  })
}

// 查询商品详情页商品仓库列表与数量
export const getBatchDetail = (batchId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/detail/stores`,
    params: {
      batchId: batchId,
    },
  })
}

// 查询商品详情页商品进货记录列表
export const getMainDetail = (listingIds) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityBatch`,
    params: {
      listingIds: listingIds,
    },
  })
}

// 进货或调拨商品
export const postStore = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityBatch/schedule`,
    method: 'post',
    data,
  })
}

// 删除商品
export const deleteCommodity = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/disable`,
    method: 'post',
    data,
  })
}

// 下架商品
export const offCommodity = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/off`,
    method: 'post',
    data,
  })
}

// 查询商品仓库类型列表
export const getStoreType = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/types`,
  })
}

// 查询商品仓库销售区域列表
export const getStoreArea = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/area`,
  })
}

// 新建或编辑商品分类
export const newOrEditCategory = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/category`,
    method: 'post',
    data,
  })
}

// 删除商品分类
export const deleteCategory = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/category/disable`,
    method: 'post',
    data,
  })
}

// 拖动排序商品分类
export const dragCategory = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/category/ordering`,
    method: 'post',
    data,
  })
}

// 查询商品仓库详情
export const getStoreDetail = (id) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/detail`,
    params: {
      id: id,
    },
  })
}

// 获取无仓库绑定的桌台
export const getUnbindingTable = (clubId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/area/tables`,
    params: {
      clubId: clubId,
    },
  })
}

// 新建或编辑商品仓库
export const newOrEditStore = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/area`,
    method: 'post',
    data,
  })
}

// 获取商品销售流水
export const getSaleJournal = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/journal/sale`,
    params,
  })
}

// 删除商品仓库
export const deleteStore = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store/disable`,
    method: 'post',
    data,
  })
}

// 商品销售流水详情
export const getSaleJournalDetail = (saleId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/journal/sale/detail`,
    params: {
      saleId: saleId,
    },
  })
}

// 查询临期商品列表
export const getExpWarning = (clubId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/warning/expirationDate`,
    params: {
      clubId: clubId,
    },
  })
}

// 查询库存告警商品列表
export const getStockWarning = (clubId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing/warning/stock`,
    params: {
      clubId: clubId,
    },
  })
}

// 商品进货记录销毁
export const destroyRecord = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityBatch/destroy`,
    method: 'post',
    data,
  })
}

// 获取商品库存流水列表
export const getStockJournal = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/journal/stock`,
    params,
  })
}

// 获取商品库存流水列表
export const getStockSummary = (clubId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/journal/stock/summary`,
    params: {
      clubId: clubId,
    },
  })
}

// 库存流水-进出记录 获取销售详情
export const getRecordDetail = (stockJournalId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/journal/stock/detail`,
    params: {
      stockJournalId: stockJournalId,
    },
  })
}

// 商品退库
export const postReduceStock = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/stock/reduce`,
    method: 'post',
    data,
  })
}

// 获取商品退库详情
export const getReduceStockDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/stock/reduce`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/businessCommodity.js